import { makeStyles } from "tss-react/mui";

export const useTabStyles = makeStyles()(() => ({
  ".ReactTable .rt-td": { padding: "0px 0px !important" },
  tabsContainerMobile: { display: "none" },
  tabsContainer: { display: "flex", flexDirection: "row", flexWrap: "wrap" },
}));
